import { defineComponent, ref, createElementBlock, openBlock, normalizeClass, createElementVNode, createCommentVNode, createVNode, withCtx, createTextVNode, toDisplayString, Fragment, renderList, createBlock, mergeProps } from 'vue';
import _sfc_main$5 from './basler-components.es75.js';
/* empty css                       */
import _sfc_main$6 from './basler-components.es70.js';
import _sfc_main$2 from './basler-components.es83.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$4 from './basler-components.es81.js';
/* empty css                       */
import _sfc_main$3 from './basler-components.es79.js';
/* empty css                       */

const _hoisted_1 = { class: "product-detail-add-to-cart__header" };
const _hoisted_2 = {
  key: 0,
  class: "product-detail-add-to-cart__header-link"
};
const _hoisted_3 = {
  key: 1,
  class: "product-detail-add-to-cart__header-link"
};
const _hoisted_4 = { class: "product-detail-add-to-cart__attributes" };
const _hoisted_5 = { class: "product-detail-add-to-cart__attribute-table" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "product-detail-add-to-cart__attribute-label" };
const _hoisted_8 = { key: 1 };
const _hoisted_9 = {
  key: 0,
  class: "product-detail-add-to-cart__attribute is-type-delivery-options"
};
const _hoisted_10 = { class: "product-detail-add-to-cart__attribute-label" };
const _hoisted_11 = { class: "product-detail-add-to-cart__delivery-options" };
const _hoisted_12 = { class: "product-detail-add-to-cart__delivery-option" };
const _hoisted_13 = { class: "product-detail-add-to-cart__delivery-option-title-box" };
const _hoisted_14 = { class: "product-detail-add-to-cart__delivery-option-title" };
const _hoisted_15 = {
  key: 0,
  class: "product-detail-add-to-cart__delivery-option-title-addition"
};
const _hoisted_16 = {
  key: 0,
  class: "product-detail-add-to-cart__delivery-option-text"
};
const _hoisted_17 = { class: "product-detail-add-to-cart__attribute-label" };
const _hoisted_18 = { class: "product-detail-add-to-cart__attribute-value-box" };
const _hoisted_19 = {
  key: 0,
  class: "product-detail-add-to-cart__attribute-value-prefix"
};
const _hoisted_20 = { class: "product-detail-add-to-cart__attribute-value" };
const _hoisted_21 = {
  key: 1,
  class: "product-detail-add-to-cart__attribute-previous-value"
};
const _hoisted_22 = {
  key: 2,
  class: "product-detail-add-to-cart__attribute-previous-value-postfix"
};
const _hoisted_23 = {
  key: 0,
  class: "product-detail-add-to-cart__amount"
};
const _hoisted_24 = {
  key: 1,
  class: "product-detail-add-to-cart__buttons"
};
const _hoisted_25 = {
  key: 1,
  class: "product-detail-add-to-cart__footer"
};
const _hoisted_26 = { class: "product-detail-add-to-cart__footer-inner" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductDetailAddToCart",
  props: {
    attributes: {},
    modelValue: { default: 1 },
    minAmount: { default: 1 },
    maxAmount: {},
    headerLinkText: {},
    headerLink: {},
    configuratorLinkText: {},
    configuratorLink: {},
    isLoading: { type: Boolean, default: false },
    loadingLines: { default: 2 },
    amountLabel: { default: "Amount" },
    addToCartButtonLabel: { default: "Add to Cart" },
    requestButtonLabel: { default: "Request individual quote" },
    showAmount: { type: Boolean, default: true },
    showAddToCartButton: { type: Boolean, default: true },
    showRequestButton: { type: Boolean, default: true },
    showConfiguratorLink: { type: Boolean, default: true },
    isAddToCartButtonDisabled: { type: Boolean, default: false },
    isRequestButtonDisabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "addToCart", "request"],
  setup(__props) {
    const props = __props;
    const amount = ref(props.modelValue);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass([
          "product-detail-add-to-cart",
          { "product-detail-add-to-cart--is-loading": props.isLoading },
          "theme-light"
        ])
      }, [
        createElementVNode("div", _hoisted_1, [
          props.isLoading && props.headerLinkText && props.headerLink ? (openBlock(), createElementBlock("div", _hoisted_2, [
            createVNode(_sfc_main$1)
          ])) : props.headerLinkText && props.headerLink ? (openBlock(), createElementBlock("div", _hoisted_3, [
            createVNode(_sfc_main$2, {
              link: props.headerLink
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(props.headerLinkText), 1)
              ]),
              _: 1
            }, 8, ["link"])
          ])) : createCommentVNode("", true),
          createElementVNode("div", _hoisted_4, [
            createElementVNode("table", _hoisted_5, [
              _ctx.isLoading ? (openBlock(), createElementBlock("tbody", _hoisted_6, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.loadingLines, (index) => {
                  return openBlock(), createElementBlock("tr", {
                    key: index,
                    class: "product-detail-add-to-cart__attribute"
                  }, [
                    createElementVNode("th", _hoisted_7, [
                      createVNode(_sfc_main$1, { style: { "width": "80%" } })
                    ]),
                    createElementVNode("td", null, [
                      createVNode(_sfc_main$1, { style: { "width": "80%", "max-width": "300px" } })
                    ])
                  ]);
                }), 128))
              ])) : (openBlock(), createElementBlock("tbody", _hoisted_8, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(props.attributes, (attribute, index) => {
                  return openBlock(), createElementBlock(Fragment, { key: index }, [
                    attribute.type === "delivery-options" ? (openBlock(), createElementBlock("tr", _hoisted_9, [
                      createElementVNode("th", _hoisted_10, toDisplayString(attribute.label), 1),
                      createElementVNode("td", null, [
                        createElementVNode("ul", _hoisted_11, [
                          (openBlock(true), createElementBlock(Fragment, null, renderList(attribute.options, (option) => {
                            return openBlock(), createElementBlock("li", {
                              key: option.title
                            }, [
                              createElementVNode("div", _hoisted_12, [
                                createElementVNode("div", _hoisted_13, [
                                  createElementVNode("span", _hoisted_14, [
                                    option.iconName ? (openBlock(), createBlock(_sfc_main$3, {
                                      key: 0,
                                      name: option.iconName,
                                      size: "dynamic",
                                      class: "product-detail-add-to-cart__delivery-option-title-icon"
                                    }, null, 8, ["name"])) : createCommentVNode("", true),
                                    createTextVNode(" " + toDisplayString(option.title), 1)
                                  ]),
                                  option.titleAddition ? (openBlock(), createElementBlock("span", _hoisted_15, toDisplayString(option.titleAddition), 1)) : createCommentVNode("", true),
                                  option.tooltip ? (openBlock(), createBlock(_sfc_main$4, mergeProps({
                                    key: 1,
                                    ref_for: true
                                  }, option.tooltip), null, 16)) : createCommentVNode("", true)
                                ]),
                                option.text ? (openBlock(), createElementBlock("p", _hoisted_16, toDisplayString(option.text), 1)) : createCommentVNode("", true)
                              ])
                            ]);
                          }), 128))
                        ])
                      ])
                    ])) : attribute.type === "attribute" ? (openBlock(), createElementBlock("tr", {
                      key: 1,
                      class: normalizeClass([
                        "product-detail-add-to-cart__attribute",
                        `product-detail-add-to-cart__attribute--${attribute.size || "medium"}`,
                        {
                          [`product-detail-add-to-cart__attribute--${attribute.layout}`]: attribute.layout,
                          [`product-detail-add-to-cart__attribute--${attribute.layout}-${attribute.layoutModifier}`]: attribute.layoutModifier,
                          "has-previous-value": attribute.previousValue
                        }
                      ])
                    }, [
                      createElementVNode("th", _hoisted_17, toDisplayString(attribute.label), 1),
                      createElementVNode("td", null, [
                        createElementVNode("div", _hoisted_18, [
                          attribute.valuePrefix ? (openBlock(), createElementBlock("div", _hoisted_19, toDisplayString(attribute.valuePrefix), 1)) : createCommentVNode("", true),
                          createElementVNode("div", _hoisted_20, toDisplayString(attribute.value), 1),
                          attribute.previousValue ? (openBlock(), createElementBlock("div", _hoisted_21, toDisplayString(attribute.previousValue), 1)) : createCommentVNode("", true),
                          attribute.previousValuePostfix ? (openBlock(), createElementBlock("div", _hoisted_22, toDisplayString(attribute.previousValuePostfix), 1)) : createCommentVNode("", true)
                        ])
                      ])
                    ], 2)) : createCommentVNode("", true)
                  ], 64);
                }), 128))
              ]))
            ])
          ])
        ]),
        _ctx.showAmount || _ctx.showAddToCartButton || _ctx.showRequestButton ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(["product-detail-add-to-cart__form", { "product-detail-add-to-cart__form--with-amount": _ctx.showAmount }])
        }, [
          _ctx.showAmount ? (openBlock(), createElementBlock("div", _hoisted_23, [
            _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              style: { "width": "62px", "height": "40px", "border-radius": "8px" }
            })) : (openBlock(), createBlock(_sfc_main$5, {
              key: 1,
              id: "amount",
              type: "number",
              modelValue: amount.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event) => amount.value = $event),
                _cache[1] || (_cache[1] = ($event) => _ctx.$emit("update:modelValue", $event))
              ],
              min: props.minAmount,
              max: props.maxAmount
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.amountLabel), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "min", "max"]))
          ])) : createCommentVNode("", true),
          _ctx.showAddToCartButton || _ctx.showRequestButton ? (openBlock(), createElementBlock("div", _hoisted_24, [
            _ctx.isLoading && _ctx.showAddToCartButton ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              type: "button"
            })) : _ctx.showAddToCartButton ? (openBlock(), createBlock(_sfc_main$6, {
              key: 1,
              "style-type": "attraction",
              "icon-type": "icon-left",
              "icon-name": "add-shopping-cart",
              "data-testid": "pdp-add-to-cart",
              "icon-scale": 1.4,
              disabled: props.isAddToCartButtonDisabled,
              onClick: _cache[2] || (_cache[2] = ($event) => _ctx.$emit("addToCart", amount.value))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.addToCartButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["disabled"])) : createCommentVNode("", true),
            _ctx.isLoading && _ctx.showRequestButton ? (openBlock(), createBlock(_sfc_main$1, {
              key: 2,
              type: "button"
            })) : _ctx.showRequestButton ? (openBlock(), createBlock(_sfc_main$6, {
              key: 3,
              "style-type": _ctx.showAddToCartButton ? "attraction-secondary" : "attraction",
              "icon-type": "no-icon",
              "data-testid": "pdp-request",
              disabled: props.isRequestButtonDisabled,
              onClick: _cache[3] || (_cache[3] = ($event) => _ctx.$emit("request", amount.value))
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.requestButtonLabel), 1)
              ]),
              _: 1
            }, 8, ["style-type", "disabled"])) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        _ctx.showConfiguratorLink && _ctx.isLoading || _ctx.showConfiguratorLink && _ctx.configuratorLinkText && _ctx.configuratorLink ? (openBlock(), createElementBlock("div", _hoisted_25, [
          createElementVNode("div", _hoisted_26, [
            props.isLoading ? (openBlock(), createBlock(_sfc_main$1, {
              key: 0,
              class: "link--configurator",
              style: { "width": "70%", "height": "28px" }
            })) : _ctx.configuratorLinkText && _ctx.configuratorLink ? (openBlock(), createBlock(_sfc_main$2, {
              key: 1,
              class: "link--configurator",
              link: _ctx.configuratorLink,
              "icon-type": "icon-left",
              "icon-name": "configurator"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(_ctx.configuratorLinkText), 1)
              ]),
              _: 1
            }, 8, ["link"])) : createCommentVNode("", true)
          ])
        ])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
